module.exports = __webpack_public_path__ + "static/media/icon_sentaku1_blue.e48a2c58.svg";